import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../Footer.module.scss';
import { CatGrid } from '@blocks-react/components/Grid';
export const FooterLinksContainer = ({ children }) => (_jsx(CatGrid, { variant: "4up", children: _jsx("div", { className: `${styles['footer-links__container']}`, "data-testid": "footerLinksContainerTestId", children: children }) }));
